import { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { SelectAllFromTable, SelectGenericFromTable, SelectRowFromTable } from '../universal/Axios';
import { IsJsonString } from '../universal/JSONHelper';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'

const store = getStore();

const EditDNCParam = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [existingDNCParamObject, setExistingDNCParamObject] = useState(null)
    const [dncParamID, setDNCParamID] = useState(id !== null ? id : "")
    const [description, setDescription] = useState("")
    const [name, setName] = useState("")
    const [parentPath, setParentPath] = useState("")
    const [standardDeviation, setStandardDeviation] = useState("")
    const [minValue, setMinValue] = useState("")
    const [maxValue, setMaxValue] = useState("")
    const [minInterval, setMinInterval] = useState("")
    const [type, setType] = useState("")

    const [existingIDs, setExistingIDs] = useState([])
    const [dncParamTypes, setDNCParamTypes] = useState([])
    const [dncParamTypeIDs, setDNCParamTypeIDs] = useState([])
    const [errorMessages, setErrorMessages] = useState({});

    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    useEffect(() => {
        SelectGenericFromTable("select id from dnc_param;", setExistingIDs)
        if (id !== null) {
            SelectRowFromTable("select * from dnc_param where id = '" + id + "';", setExistingDNCParamObject)
        }
    }, []);

    useEffect(() => {
        setDNCParamTypeIDs(dncParamTypes.map(x => x.id))
    }, dncParamTypes)

    useEffect(() => {
        if (existingDNCParamObject !== null) {
            if (existingDNCParamObject.description !== undefined) {
                setDescription(existingDNCParamObject.description)
            }
            if (existingDNCParamObject.name !== undefined) {
                setName(existingDNCParamObject.name)
            }
            if (existingDNCParamObject.parent_path !== undefined) {
                setParentPath(existingDNCParamObject.parent_path)
            }
            if (existingDNCParamObject.standard_deviation !== undefined) {
                setStandardDeviation(existingDNCParamObject.standard_deviation)
            }
            if (existingDNCParamObject.min_value !== undefined) {
                setMinValue(existingDNCParamObject.min_value)
            }
            if (existingDNCParamObject.max_value !== undefined) {
                setMaxValue(existingDNCParamObject.max_value)
            }
            if (existingDNCParamObject.min_interval !== undefined) {
                setMinInterval(existingDNCParamObject.min_interval)
            }
            if (existingDNCParamObject.type !== undefined) {
                setType(existingDNCParamObject.type)
            }
        }
    }, [existingDNCParamObject])

    useEffect(() => {
        validateForm()
    }, [dncParamID, parentPath])

    const checkSubmitButtonDisabled = () => {
        const has_errors = Object.keys(errorMessages).map(x => errorMessages[x]).some(x => x !== "")
        setSubmitButtonDisabled(has_errors)
    }

    useEffect(() => {
        checkSubmitButtonDisabled()
    }, [errorMessages])

    const validateForm = () => {
        //ID Section
        if (existingIDs.map(x => x["id"]).indexOf(dncParamID) === -1 || id !== null) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["uniqueness"]: "A density network config with that ID already exists" }))
        }

        if (dncParamID === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "No ID" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_id"]: "" }))
        }
        if (dncParamID.includes(".") || dncParamID.includes("\"") || dncParamID.includes("(") || dncParamID.includes(")")) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["id_special_characters"]: "The ID is not allowed to contain special characters" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["id_special_characters"]: "" }))
        }

        //File Content Section
        if (parentPath === "") {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "No parent path content" }))
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "" }))
        }
        else if (!IsJsonString(parentPath)) {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "Parent Path is not valid JSON" }))
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "" }))
        }
        else {
            setErrorMessages(errorMessages => ({ ...errorMessages, ["is_valid_json"]: "" }))
            setErrorMessages(errorMessages => ({ ...errorMessages, ["has_file_content"]: "" }))
        }
    }

    useEffect(() => {
        SelectAllFromTable('dnc_param_type', setDNCParamTypes)
    }, [])

    const createDNCParam = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": id == null ? "Create_DNC_Param" : "Edit_DNC_Param",
                "id": id == null ? dncParamID : id,
                "description": description,
                "name": name,
                "parent_path": parentPath,
                "standard_deviation": standardDeviation,
                "min_value": minValue,
                "max_value": maxValue,
                "min_interval": minInterval,
                "type": type
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully " + (id == null ? "created" : "edited") + " DNC Param!")
            window.location.href = "/dnc-params"
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    return (
        <Box>
            <Typography variant="h5">{id == null ? "Create" : "Edit"} DNC Param</Typography>
            {Object.keys(errorMessages).map(x => <Typography color="red">{errorMessages[x]}</Typography>) }
            <Box sx={{ height: '80px', marginTop: '20px' }}>
                <FormControl style={{ width: '45%', marginRight: '20px', marginBottom: '25px' }}>
                    <TextField
                        id="id"
                        label="DNC Param ID"
                        onChange={(event) => setDNCParamID(event.target.value)}
                        required
                        value={id !== null ? id : dncParamID}
                        readOnly={id !== null}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '45%' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setDescription(event.target.value)}
                        value={description}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <InputLabel id="type">Param Type</InputLabel>
                    <Select
                        id="type"
                        label="Type"
                        value={type}
                        variant="outlined"
                        onChange={(event) => setType(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {dncParamTypes && dncParamTypes?.map(x => <MenuItem value={x.id} style={{ display: "block" }}><b>{x.id}</b>: {x.description}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <TextField
                        id="name"
                        label="Name"
                        onChange={(event) => setName(event.target.value)}
                        required
                        value={name}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <TextField
                        id="min_value"
                        label="Min Value"
                        onChange={(event) => setMinValue(event.target.value)}
                        required
                        value={minValue}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <TextField
                        id="max_value"
                        label="Max Value"
                        onChange={(event) => setMaxValue(event.target.value)}
                        required
                        value={maxValue}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <TextField
                        id="min_interval"
                        label="Min Interval"
                        onChange={(event) => setMinInterval(event.target.value)}
                        required
                        value={minInterval}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '45%', marginBottom: '25px', marginRight: '20px' }}>
                    <TextField
                        id="standard_deviation"
                        label="Standard Deviation"
                        onChange={(event) => setStandardDeviation(event.target.value)}
                        required
                        value={standardDeviation}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '300px', width: '100%', marginBottom: '25px' }}>
                <FormControl fullWidth sx={{ height: '300px' }}>
                    <TextField
                        id="parent_path"
                        label="Parent Path"
                        variant="outlined"
                        multiline
                        rows={10}
                        value={parentPath}
                        maxRows={5000}
                        onChange={(event) => setParentPath(event.target.value)}
                        helperText={errorMessages.id}
                    />
                </FormControl>
            </Box>
            <Box sx={{ m: 2, height: '10px', }}>
                <Box style={{ width: '90%', height: '10px', display: 'inline-block', float: 'left' }}>
                    <Box sx={{ m: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" href={"dnc-params"}>Cancel</Button>
                            <Button variant="outlined" onClick={() => createDNCParam()} disabled={isSubmitButtonDisabled}>Submit</Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default EditDNCParam;
